module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('navbar'), _vm._v(" "), _c('div', {
    staticClass: "ipoint-success"
  }, [_c('div', {
    staticClass: "ipoint-success-content"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/profile/success.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ipoint-remaining"
  }, [_vm._v(_vm._s(_vm.$t('user_center_iPoint_Remaining')) + ": " + _vm._s(_vm.ipoint))]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'FooterShop'
      }
    }
  }, [_c('a', {
    staticClass: "ipoint-continue-shopping",
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v(_vm._s(_vm.$t('continue_purchase')) + "\n                    "), _c('Icon', {
    attrs: {
      "type": "chevron-right"
    }
  })], 1)])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "max_width"
  }, [_c('guess')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1e1863e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/iPointSuccess.vue
// module id = 849
// module chunks = 0